<template>
    <div>
        <TransitionFadeShort v-show="load">
            <MoleculeSkeletonCard />
        </TransitionFadeShort>

        <TransitionFadeShort v-show="!load && sortedData.length === 0">
            <p class="text-white">{{ $t('search.all_empty') }}</p>
        </TransitionFadeShort>

        <TransitionFadeShort>
            <MasonryGrid
                v-if="renderMasonryGrid"
                :align="masonryAlign"
                :gap="masonryGap"
                :useResizeObserver="true"
                :observeChildren="true"
            >
                <router-link
                    v-show="!load"
                    v-for="item in sortedData" :key="item.model + item.id"
                    :to="navigateToItem(item)"
                    class="pb-10 hover:cursor-pointer hover:opacity-70 transition ease-in-out duration-200 absolute w-[48%] md:w-[23%] xl:w-[15%]"
                >
                    <img
                        class="rounded-md min-h-[70px] w-full bg-gray-500"
                        :src="item.cover.cached_url"
                        loading="lazy"
                        :alt="item.name"
                    />
                    <div
                        v-if="(item.types && item.types.length) || item.model === 'people'"
                        class="border-2 text-sm border-gray-400 rounded-md px-2 py-0.5 text-white mt-3 inline-block"
                    >
                        {{ item.model === "people" ? $t('search.people') : item.types.length ? item.types[0].name : null }}
                    </div>
                    <p class="text-white mt-6"> {{ item.name }} </p>

                    <p
                        v-if="item.starting_date && item.model === 'event'"
                        class="text-white opacity-50 mt-1"
                    >
                        {{ formatDate(item.starting_date) }}
                    </p>
                </router-link>
            </MasonryGrid>
        </TransitionFadeShort>
    </div>
</template>

<script>
import MoleculeSkeletonCard from "../molecules/MoleculeSkeletonCard.vue";
import TransitionFadeShort from "../../../transitions/TransitionFadeShort.vue";
import { MasonryGrid } from '@egjs/vue-grid';
import {nextTick} from "vue";
import {formatDate} from "../../../utils/formatDate";

export default {
    name: "OrganismTabAll",
    components: {TransitionFadeShort, MoleculeSkeletonCard, MasonryGrid },
    props: {
        data: null,
        load: false,
    },
    data(){
        return{
            masonryAlign: 'justify',
            masonryGap: 0,
            renderMasonryGrid: true,
        }
    },
    computed: {
        sortedData() {
            if (this.data && this.data.length > 0) {
                return this.data.sort((a, b) => {
                    return new Date(a.starting_date) - new Date(b.starting_date);
                }).reverse();
            }
            return [];
        },
    },
    watch:{
        sortedData: function (){
            this.handleResize()
            this.forceReRender()
        }
    },
    methods: {
        formatDate,
        handleResize() {
            if (window.innerWidth > 1280) {
                this.setMasonryProperties(6);
            } else if (window.innerWidth > 768) {
                this.setMasonryProperties(4);
            } else {
                this.setMasonryProperties(0);
            }
        },

        async forceReRender() {
            //Force re render masonry grid
            this.renderMasonryGrid = false;
            await nextTick();
            this.renderMasonryGrid = true;
        },

        setMasonryProperties(itemLimit) {
            this.masonryAlign = itemLimit ? (this.sortedData.length < itemLimit ? 'start' : 'justify') : 'justify';
            this.masonryGap = itemLimit ? (this.sortedData.length < itemLimit ? 25 : 0) : 0;
        },

        navigateToItem(item) {
            let routeName = '';
            let routeParams = {};

            if (item.model === 'people') {
                routeName = 'people.view';
            } else if (item.model === 'event') {
                routeName = 'event.view';
            } else if (item.model === 'project') {
                routeName = 'project.view';
            }

            routeParams.id = item.id;
            routeParams.slug = item.slug;

            return { name: routeName, params: routeParams };
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>
